import * as React from 'react';
import { LinkLegacy as Link } from '@leagueplatform/routing';
import {
  getScopedLegacyCssClassNames,
  useDynamicHeaderHeight,
} from '@leagueplatform/web-common';
import {
  BackButtonArrow,
  PageHeaderBackground,
} from '@leagueplatform/web-common-components';
import { Box, HeadingText, StackLayout } from '@leagueplatform/genesis-core';

export type CarePageWrapperProps = {
  children: React.ReactNode;
  backButtonPath?: string;
  backButtonOnClick?: () => void;
  title?: string;
};

export function CarePageWrapper({
  backButtonPath,
  backButtonOnClick,
  children,
  title,
}: CarePageWrapperProps) {
  const { height, pageHeaderBackgroundHeight, contentRef } =
    useDynamicHeaderHeight();
  return (
    <StackLayout
      className={`${getScopedLegacyCssClassNames()} care-page-wrapper`}
      css={{
        maxWidth: '1272px',
        width: '100%',
        paddingInline: '$oneAndHalf',
        marginInline: 'auto',
        justifyContent: 'center',
        paddingBlock: '40px',
        '@desktop': {
          paddingBlock: '56px',
        },
        '@laptop': {
          paddingBlock: '56px',
        },
      }}
    >
      {title && (
        <PageHeaderBackground
          height={height}
          pageHeaderBackgroundHeight={pageHeaderBackgroundHeight}
        >
          <StackLayout css={{ position: 'relative' }}>
            <Box ref={contentRef}>
              <StackLayout
                orientation="horizontal"
                verticalAlignment="center"
                spacing={{ '@initial': '$oneAndHalf', '@mobile': '$half' }}
                css={{
                  '@mobile': { flexWrap: 'wrap', alignContent: 'center' },
                }}
              >
                {(backButtonPath || backButtonOnClick) && (
                  <BackButtonArrow
                    as={Link}
                    to={backButtonPath}
                    onClick={backButtonOnClick}
                  />
                )}
                <Box css={{ width: '100%' }}>
                  {title && (
                    <HeadingText
                      level="1"
                      size={{ '@initial': 'xxl', '@mobile': 'xl' }}
                      css={{ flexGrow: 1 }}
                    >
                      {title}
                    </HeadingText>
                  )}
                </Box>
              </StackLayout>
            </Box>
          </StackLayout>
        </PageHeaderBackground>
      )}
      {!title && (
        <StackLayout orientation="horizontal" verticalAlignment="center">
          {(backButtonPath || backButtonOnClick) && (
            <BackButtonArrow
              as={Link}
              to={backButtonPath}
              onClick={backButtonOnClick}
            />
          )}
        </StackLayout>
      )}
      <Box css={{ marginBlock: '$twoAndHalf', width: '100%' }}>{children}</Box>
    </StackLayout>
  );
}
